import React from 'react';
import PropTypes from 'prop-types';
import { isResponseSuccess } from 'helpers';
import { LOGIN } from '../../../constants';
import eyeOff from 'assets/img/eye-icon-off.svg';
import eyeOn from 'assets/img/eye-icon-on.svg';
import checkOn from 'assets/img/checkmark-icon-on.svg';
import checkOff from 'assets/img/checkmark-icon-off.svg';
import alertIcon from 'assets/img/alert-icon.svg';

class NewPassword extends React.Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
    sendNewCredentials: PropTypes.func.isRequired,
    validationCode: PropTypes.string.isRequired,
    history: PropTypes.object,
    handleGoback: PropTypes.func.isRequired,
    isResetError: PropTypes.bool,
    sendMethod: PropTypes.shape({
      deliveryDestination: PropTypes.string,
      deliveryType: PropTypes.string,
      closeOppCount: PropTypes.string,
      userName: PropTypes.string
    })
  }

    state = {
      isPasswordVisible: false,
      isPasswordConfirmVisible: false,
      showMatchingAlert: false,
      loading: false,
      newPassword: '',
      passwordConfirm: '',
      eyeIcon1: false,
      eyeIcon2: false,
      req1: false,
      req2: false,
      req3: false,
      req4: false
    }

      confirmEquality = () => {
        if (this.state.passwordConfirm !== this.state.newPassword) {
          this.setState({ showMatchingAlert: true });
        }
      }

      togglePassword = (target) => {
        if (target === 'new-confirm') {
          this.setState({
            isPasswordVisible: !this.state.isPasswordVisible,
            eyeIcon1: !this.state.eyeIcon1
          });
        } else {
          this.setState({
            isPasswordConfirmVisible: !this.state.isPasswordConfirmVisible,
            eyeIcon2: !this.state.eyeIcon2
          });
        }
      }

      handlePasswordChange = (event) => {
        const has8Char = /.{8,}/;
        const hasUpperCase = /[A-Z]+/;
        const hasLowerCase = /[a-z]+/;
        const hasOneNumber = /[0-9]+/;

        this.setState({
          [event.target.name]: event.target.value,
          showMatchingAlert: false
        });

        if (event.target.name === 'newPassword') {
          event.target.value.match(has8Char) ? this.setState({ req1: true }) : this.setState({ req1: false });
          event.target.value.match(hasUpperCase) ? this.setState({ req2: true }) : this.setState({ req2: false });
          event.target.value.match(hasLowerCase) ? this.setState({ req3: true }) : this.setState({ req3: false });
          event.target.value.match(hasOneNumber) ? this.setState({ req4: true }) : this.setState({ req4: false });
        }
      }

    SubmitPasswordChange = async (event) => {
      event.preventDefault();
      const { deliveryType, deliveryDestination } = this.state;
      const payload = {
        deliveryType: deliveryType,
        deliveryDestination: deliveryDestination,
        userName: this.props.sendMethod.userName,
        newPassword: this.state.newPassword,
        confirmPassword: this.state.passwordConfirm,
        authenticationCode: this.props.validationCode
      };

      if (!this.state.showMatchingAlert) {
        const res = await this.props.sendNewCredentials(payload);
        if (isResponseSuccess(res)) { this.LoginUser(); }
      } else { return false; }
    }

   LoginUser = async () => {
     const loginResponse = await this.props.login(this.props.sendMethod.userName, this.state.newPassword);
     if (isResponseSuccess(loginResponse)) {
       this.props.history.push('/dashboard');
     }
   }

   render () {
     const isPassordVisible = this.state.isPasswordVisible ? 'text' : 'password';
     const isConfirmVisible = this.state.isPasswordConfirmVisible ? 'text' : 'password';
     const { eyeIcon1, eyeIcon2, req1, req2, req3, req4, req5 } = this.state;

     return (

       <React.Fragment>
         <form className='login-content'>
           <div className='password-container'>
             <div className='login-bold-header'>
                Enter New Password
             </div>
             <div className='login-body-text'>
               {LOGIN.FORGOT_YOUR_PASSWORD}
             </div>
             <div className='input-wrapper'>
               <img className='password-icon' src={eyeIcon1 ? eyeOn : eyeOff} onClick={() => this.togglePassword('new-confirm')} />
               <input autoFocus type={isPassordVisible} id='login-password' name='newPassword' autoComplete='off'
                 className='login-form' placeholder='New Password' onChange={this.handlePasswordChange} />
             </div>
             <div className='input-message-alert'>
               <img className='password-icon' src={eyeIcon2 ? eyeOn : eyeOff}
                 onClick={this.togglePassword} />
               <input type={isConfirmVisible} id='login-password-confirm' name='passwordConfirm' autoComplete='off'
                 className='login-form' placeholder='Confirm new password' onChange={this.handlePasswordChange}
                 onBlur={this.confirmEquality} />
             </div>
             { this.state.showMatchingAlert &&
             <div className='alert-message fade-in'>
               <div><img className='alert-icon' src={alertIcon} /></div>
               <div>{' The passwords you entered do not match. Please try again.'}</div>
             </div>
             }
             <div className='login-password-req'>Your password must:</div>
             <RenderChecked isChecked={req1}>Be at least 8 characters</RenderChecked>
             <RenderChecked isChecked={req2}>Have at least one capital letter</RenderChecked>
             <RenderChecked isChecked={req3}>Have at least one lower case letter</RenderChecked>
             <RenderChecked isChecked={req4}>Have at least one number</RenderChecked>
             <RenderChecked isChecked={req5} isErrorAlert={this.props.isResetError} >Not a password previously used</RenderChecked>
           </div>
           <div className='bottom-button-wrapper'>
             <div>
               <button onClick={this.props.handleGoback} className='login-back-btn' type='reset'>
                   Back
               </button>
             </div>
             <div className=' push'>
               <button disabled={!(req1 && req2 && req3 && req4)}
                 onClick={this.SubmitPasswordChange} className='login-primary-button' type='submit'>
                  Change Password
               </button>
             </div>
           </div>
         </form>
       </React.Fragment>
     );
   }
}

export default NewPassword;

function RenderChecked ({ ...props }) {
  RenderChecked.propTypes = {
    isChecked: PropTypes.bool,
    isErrorAlert: PropTypes.bool,
    children: PropTypes.string
  };

  let checkImage = checkOff;
  let messageFormat = 'grey-check';

  if (props.isChecked) {
    messageFormat = 'req-checked';
    checkImage = checkOn;
  }

  if (props.isErrorAlert) {
    messageFormat = 'req-alert';
    checkImage = alertIcon;
  }

  return (
    <div className={'req-check'}>
      <img src={checkImage} className={'req-img'} /><span className={messageFormat}>{props.children}</span>
    </div>
  );
}
